import {E, GetEntries} from "js-vextensions";
import {runInAction} from "mobx";
import {Row, Select} from "react-vcomponents";
import {BaseComponentPlus} from "react-vextensions";
import {ScrollView} from "react-vscrollview";
import {store} from "../../Store/index.js";
import {GetBundles} from "../../Server/DB/bundles.js";
import {GetSelectedEngineConfig} from "../../Server/DB/engineConfigs.js";
import {GetEntities} from "../../Server/DB/entities.js";
import {GetLights} from "../../Server/DB/lights.js";
import {GetShakes} from "../../Server/DB/shakes.js";
import {GetSounds} from "../../Server/DB/sounds.js";
import {EngineTab} from "../../Store/main/engine/config.js";
import {useExpandedNavBar} from "../@Shared/NavBar.js";
import {ES} from "web-vcore";
import {Observer, PageContainer, RunInAction} from "web-vcore";
import {GetScripts} from "../../Server/DB/scripts.js";
import {MeID} from "../../Server/DB/users.js";
import {HasModPermissions} from "../../Server/DB/users/$user.js";
import {EngineConfigPanel_Client} from "./Engine/ConfigPanel_Client.js";
import {SessionLogPanel} from "../Tools/@Shared/BetweenSessionTypes/SessionLogPanel.js";
import {SessionStatsPanel} from "./Engine/SessionStatsPanel.js";
import {SessionTimelinePanel} from "./Engine/SessionTimelinePanel.js";
import {ConfigPanel_Local} from "./Engine/ConfigPanel_Local.js";
import React from "react";
import {observer_mgl} from "mobx-graphlink";

// ui
// ==========

export const ConfigUI = observer_mgl(()=>{
	const tab = store.main.engine.config.tab;
	// these are just here so we have synchronous access to them in FBASession.ts
	const bundles = GetBundles();
	const entities = GetEntities();
	const sounds = GetSounds();
	const shakes = GetShakes();
	const lights = GetLights();
	const scripts = GetScripts(); //GetScripts(MeID());
	//localConfig: State(a=>a.main.engine.config.localConfig),
	const config = GetSelectedEngineConfig();

	const largeVersion = useExpandedNavBar();
	let engineTabOptions = GetEntries(EngineTab);
	// these tabs are not useful for other users atm
	if (!HasModPermissions(MeID())) {
		engineTabOptions = engineTabOptions.filter(a=>!a.name.IsOneOf("Timeline", "Stats"));
	}

	return (
		<PageContainer preset="text" style={E(
			{padding: 0},
			tab == EngineTab.Log && {height: "calc(100% - 70px)"},
			!largeVersion && {margin: "20px auto 20px auto"},
		)}>
			<Row>
				<Select displayType="button bar" options={engineTabOptions} value={store.main.engine.config.tab} onChange={val=>{
					RunInAction("EngineUI.tab.onChange", ()=>store.main.engine.config.tab = val);
				}}/>
			</Row>
			<ScrollView style={ES({flex: 1, padding: 10})} contentStyle={{display: "flex", flexDirection: "column"}}>
				{tab == EngineTab.Host && <ConfigPanel_Local journeyUI={false}/>}
				{tab == EngineTab.Client && <EngineConfigPanel_Client/>}
				{tab == EngineTab.Log && <SessionLogPanel/>}
				{tab == EngineTab.Timeline && <SessionTimelinePanel/>}
				{tab == EngineTab.Stats && <SessionStatsPanel/>}
			</ScrollView>
		</PageContainer>
	);
});